import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import {
  ButtonWrapper,
  GroupOverlayCenter,
  GroupOverlayInner,
  LabelWrapper,
  SVGWrapper,
  Table,
  Td,
  Th,
  Thead,
  Tr
} from '../managedITServices/components/css';
import CancelSVG from '../managedITServices/assets/svg/cancel';
import SaveSVG from '../managedITServices/assets/svg/save';
import EditSVG from '../managedITServices/assets/svg/edit';
import SubscriptionLineOption from './subscriptionLineOption';
import ValidateLoader from '../../../UI/validateLoader';

import {
  changeOption,
  changeOptionPricing,
  deleteOption,
  saveOption,
  saveOptionPricing
} from '../managedITServices/components/saveSchemaToDB';

const SubscriptionLine = ({
  microsoftLicensingAdminData,
  setMicrosoftLicensingAdminData,
  categorySelected,
  editMode,
  setEditMode,
  categoryEditMode,
  setIsOptionSelected
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [dataSaved,setDataSaved] = useState(false);
  const [deleteOptions,setDeleteOptions] = useState([]);
  const [isLoading,setIsLoading] = useState(false);

    // Saving initial microsoftLicensingAdminData
    useEffect(() => {
        const clonedAdminData = JSON.parse(
        JSON.stringify(microsoftLicensingAdminData)
        );
        setInitialData(clonedAdminData);
        setDataSaved(false);
    }, [dataSaved]);

  useEffect(() => {
    setIsOptionSelected(selectedOption);
  }, [selectedOption]);
  useEffect(() => {
    // Check if categorySelected exists and if the corresponding data is available
    if (categorySelected && microsoftLicensingAdminData[categorySelected]) {
      const options =
        microsoftLicensingAdminData[categorySelected].productCatalogOptions;

      // If productCatalogOptions exists and is an array with length, use it
      if (Array.isArray(options) && options.length > 0) {
        setSubscriptionList(options);
      } else {
        // Assign a default object if the array is empty or doesn't exist
        setSubscriptionList([
          {
            questionId: '',
            id: '',
            ord:'',
            name: '',
            subscriptionId: '',
            subscriptionPlan: '',
            subscriptionItem: '',
            productCatalogPricings: [
              {
                optionId: '',
                id: '',
                cost: 0,
                onetimePrice: 0,
                costPremium: 0,
                onetimePricePremium: 0,
                operationType: 'ADD'
              }
            ]
          }
        ]);
      }
    } else {
      // If no category is selected or data doesn't exist, reset to an empty array
      setSubscriptionList([]);
    }
  }, [categorySelected, microsoftLicensingAdminData]); // Dependencies for useEffect

  const subscriptionLineOptionValid = () =>
    microsoftLicensingAdminData[categorySelected].productCatalogOptions.every(
      ({
        name,
        subscriptionId,
        subscriptionItem,
        subscriptionPlan,
        productCatalogPricings: [{ cost, onetimePrice }]
      }) =>
        name &&
        subscriptionId &&
        subscriptionItem &&
        subscriptionPlan &&
        !isNaN(cost) &&
        !isNaN(onetimePrice)
    );
    const handleDeleteOptions = async  () => {
        deleteOptions.forEach(async (optionId)=>{
        if(optionId)
            {
                await deleteOption(optionId);
            }
    
        });
       
      };

  const handleSave = async () => {
    if(deleteOptions.length !==0)
        {
            await handleDeleteOptions();
        }
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    const questionId = clonedAdminData[categorySelected].id;
    const updatedOptions =
      clonedAdminData[categorySelected].productCatalogOptions;

    if (subscriptionLineOptionValid()) {
        try{
            setIsLoading(true);
        if (questionId) {
            // Loop through the options to decide whether to update or save a new option
            const saveOptionPromises = updatedOptions.map(async (option, index) => {
            const updatedPricing = option.productCatalogPricings[0];
            if (option.id) {
                // Existing option -> Update with changeOption
                let pricingId = null;
                pricingId =
                option.productCatalogPricings &&
                option.productCatalogPricings.length > 0
                    ? option.productCatalogPricings[0].id
                    : null;
                await changeOption(option.id, {
                questionId,
                ord:index,
                name: option.name,
                subscriptionId: option.subscriptionId,
                subscriptionItem: option.subscriptionItem,
                subscriptionPlan: option.subscriptionPlan
                });
                if (pricingId) {
                await changeOptionPricing({
                    id: pricingId,
                    cost: +updatedPricing.cost,
                    onetimePrice: +updatedPricing.onetimePrice,
                    costPremium: +updatedPricing.costPremium,
                    onetimePricePremium: +updatedPricing.onetimePricePremium,
                    operationType: 'ADD'
                });
                }

                // eslint-disable-next-line no-else-return
            } else {
                // New option -> Save with saveOption
                const newOptionId = await saveOption(questionId, {
                questionId,
                ord:index,
                name: option.name,
                subscriptionId: option.subscriptionId,
                subscriptionItem: option.subscriptionItem,
                subscriptionPlan: option.subscriptionPlan
                });
                const newPricingId = await saveOptionPricing(newOptionId, {
                optionId: newOptionId,
                cost: +updatedPricing.cost,
                onetimePrice: +updatedPricing.onetimePrice,
                costPremium: +updatedPricing.costPremium,
                onetimePricePremium: +updatedPricing.onetimePricePremium,
                operationType: 'ADD'
                });
                clonedAdminData[categorySelected].productCatalogOptions[
                index
                ].questionId = questionId;
                clonedAdminData[categorySelected].productCatalogOptions[
                index
                ].id = newOptionId;
                clonedAdminData[categorySelected].productCatalogOptions[
                    index
                ].ord = index;
                clonedAdminData[categorySelected].productCatalogOptions[
                index
                ].productCatalogPricings[0].id = newPricingId;
                clonedAdminData[categorySelected].productCatalogOptions[
                index
                ].productCatalogPricings[0].optionId = newOptionId;
            }
            });

            // Await all promises for saving and updating options
            await Promise.all(saveOptionPromises);
            setDataSaved(true);
            console.log('All options processed successfully');
        }
    }catch (error) {
        console.error('Error while saving questions:', error);
        alert("An Error occurred, Please try again");
        setIsLoading(false);
      }
      finally{
        setIsLoading(false);
      }

      setMicrosoftLicensingAdminData(clonedAdminData);
      setEditMode(!editMode);
    }
  };

  const handleCancel = () => {
    setDeleteOptions([]);
    const clonedAdminData = JSON.parse(JSON.stringify(initialData));
    const filteredData = clonedAdminData.filter(option=>option.id && option.name);
    setMicrosoftLicensingAdminData(filteredData);
    setEditMode(false);
  };

  useEffect(() => {
    setSelectedOption('');
  }, [editMode]);

  useEffect(() => {
    setSelectedOption('');
  }, [categorySelected]);

  return (
    <>
    {isLoading && (
        <GroupOverlayCenter>
          <GroupOverlayInner>
            {/* Please wait request is In progress.... */}
            <ValidateLoader
                message="Please wait request is In progress...."
                isFormStep={isLoading}
            />
          </GroupOverlayInner>
        </GroupOverlayCenter>
      )}
      <Tr>
        <Td background="#f7f7f7">
          <LabelWrapper>
            <span>Subscription Line Option</span>
            {categorySelected && !categoryEditMode && (
              <ButtonWrapper>
                {editMode ? (
                  <>
                    <SVGWrapper onClick={handleCancel}>
                      <CancelSVG />
                    </SVGWrapper>
                    <SVGWrapper onClick={handleSave}>
                      <SaveSVG />
                    </SVGWrapper>
                  </>
                ) : (
                  <>
                    <SVGWrapper onClick={() => setEditMode(!editMode)}>
                      <EditSVG />
                    </SVGWrapper>
                  </>
                )}
              </ButtonWrapper>
            )}
          </LabelWrapper>
        </Td>

        {editMode ? (
          <SubscriptionLineOption
            key={subscriptionList[0].id}
            initialData={initialData}
            setInitialData={setInitialData}
            microsoftLicensingAdminData={microsoftLicensingAdminData}
            setMicrosoftLicensingAdminData={setMicrosoftLicensingAdminData}
            subscriptionListItem={subscriptionList[0]}
            categoryIndex={categorySelected}
            subscriptionListIndex={0}
            isLast={subscriptionList.length === 1}
            isFirst={true}
            deleteOptions={deleteOptions}
            setDeleteOptions={setDeleteOptions}
          />
        ) : (
          <>
            <Td>
              <select
                name="subscriptionLine"
                id="subscriptionLine"
                onChange={e => setSelectedOption(e.target.value)}
              >
                <option value="">Select subscription Line Option</option>
                {subscriptionList.map((listItem, index) => (
                  <option value={index}>{listItem.name}</option>
                ))}
              </select>
            </Td>
            <Td>
              {selectedOption
                ? `$${_.get(
                    subscriptionList,
                    `[${selectedOption}].productCatalogPricings[0].cost`,
                    '-'
                  )}`
                : '-'}
            </Td>
            <Td>
              {selectedOption
                ? `$${_.get(
                    subscriptionList,
                    `[${selectedOption}].productCatalogPricings[0].onetimePrice`,
                    '-'
                  )}`
                : '-'}
            </Td>
          </>
        )}
      </Tr>
      {editMode && (
        <>
          {subscriptionList
            .slice(1)
            .map((subscriptionListItem, subscriptionListIndex) => (
              <SubscriptionLineOption
              key={subscriptionListItem.id}
                initialData={initialData}
                setInitialData={setInitialData}
                microsoftLicensingAdminData={microsoftLicensingAdminData}
                setMicrosoftLicensingAdminData={setMicrosoftLicensingAdminData}
                subscriptionListItem={subscriptionListItem}
                categoryIndex={categorySelected}
                subscriptionListIndex={subscriptionListIndex + 1}
                isLast={subscriptionListIndex === subscriptionList.length - 2}
                isFirst={false}
                deleteOptions={deleteOptions}
                setDeleteOptions={setDeleteOptions}
              />
            ))}
        </>
      )}
    </>
  );
};

export default SubscriptionLine;
